import styled, { css } from 'styled-components';
import { ReactComponent as Cross } from '../../../../assets/img/cross.svg';

export const StyledCross = styled(Cross)`
  position: absolute;
  top: 20px;
  right: 15px;
  z-index: 2;
  width: 14px;
  height: 14px;
  fill: ${({ theme }) => theme.text};
  path {
    fill: currentColor;
  }
  cursor: pointer;
`;
export const StyledRightBlock = styled.aside`
  padding: 0px 0px 100px 0px;
  max-height: calc(100vh - ${({ theme }) => theme.headerHeight});
  z-index: 10;
  overflow: auto;
  position: fixed;
  right: 0;
  top: ${({ theme }) => theme.headerHeight};
  height: 100%;
  background: ${({ theme }) => theme.card};
  border: 0;
  color: ${({ theme }) => theme.text};
  transition: 0.2s;
  width: 300px;
  ${({ hasTopHeader }) => {
    if (hasTopHeader) {
      return css`
        top: ${({ theme }) => theme.headerHeight};
      `;
    }
  }}
  @media screen and (max-width: 1100px) {
    top: ${({ theme }) => theme.headerHeight};
  }
  @media screen and (max-width: 426px) {
    padding: 0px;
    top: ${({ theme }) => theme.headerHeight};
    max-height: calc(100vh - ${({ theme }) => theme.headerHeight});
    ${({ hasTopHeader }) => {
    if (hasTopHeader) {
      return css`
          top: ${({ theme }) => theme.headerHeight};
          max-height: calc(100vh - ${({ theme }) => theme.headerHeight});
        `;
    }
  }}
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    border-top-left-radius: ${({ theme }) => theme.chromeRadius};
    border-top-right-radius: ${({ theme }) => theme.chromeRadius};
    isolation: isolate;
  }
  @media screen and (min-width: 769px) and (max-width: 1200px) {
    // width: 100%;
    max-width: inherit;
  }
  &[data-right='false'] {
    transform: translate3d(100%, 0, 0);
    box-shadow: none;
    border-left: 0;
  }
  &[data-right='true'] {
    border-left: 1px solid ${({ theme }) => theme.border};
    box-shadow: ${({ theme }) =>
      theme.isDark
        ? '-4px 0 12px rgba(0, 0, 0, 0.25)'
        : '-4px 0 12px rgba(0, 0, 0, 0.06)'};
  }
  &.right-sidebar {
    @media screen and (max-width: 768px) {
      height: 100vh;
    }
  }
`;
